import { render, staticRenderFns } from "./ExplorePage.vue?vue&type=template&id=a0640d4a"
import script from "./ExplorePage.vue?vue&type=script&lang=js"
export * from "./ExplorePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports